import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'

const ReactionPillPure = ({ emoji, count, variant }) => {
  return (
    <div className={`${styles.reactionButton} ${styles[variant]}`}>
      <span className={styles.emoji}>{emoji}</span>
      {count > 0 && <span>{count}</span>}
    </div>
  )
}

export default ReactionPillPure
